import { AbilityBuilder, createMongoAbility } from '@casl/ability';
export function defineAbilitiesFor(user, org) {
    const { can, cannot, build } = new AbilityBuilder(createMongoAbility);
    // Anyone authenticated can manage their own User profile.
    can('manage', 'User');
    // Without a membership in the active org, no org-scoped abilities.
    if (!user.role || !user.orgId || !org || user.orgId !== org.id) {
        return build();
    }
    // All roles can read the org they belong to and their own member row.
    can('read', 'Organization');
    can('read', 'Member');
    if (user.role === 'Admin') {
        can('manage', 'Organization');
        can('manage', 'Member');
        can('manage', 'Invitation');
        can('read', 'AuditLog');
        // Wave 1 bookkeeping subjects
        can('manage', 'Account');
        can('manage', 'Customer');
        can('manage', 'Vendor');
        can('manage', 'Item');
        can('manage', 'JournalEntry');
        can('manage', 'TaxRate');
        can('manage', 'WithholdingRate');
        can('manage', 'Invoice');
        can('manage', 'SalesReceipt');
        can('manage', 'ReceivePayment');
    }
    else if (user.role === 'Bookkeeper') {
        cannot('manage', 'Member');
        cannot('manage', 'Invitation');
        cannot('read', 'AuditLog');
        // Wave 1 bookkeeping subjects
        can('manage', 'Account');
        can('manage', 'Customer');
        can('manage', 'Vendor');
        can('manage', 'Item');
        can('manage', 'JournalEntry');
        can('manage', 'TaxRate');
        can('manage', 'WithholdingRate');
        can('manage', 'Invoice');
        can('manage', 'SalesReceipt');
        can('manage', 'ReceivePayment');
    }
    else if (user.role === 'Reports-only') {
        cannot('manage', 'Member');
        cannot('manage', 'Invitation');
        cannot('read', 'AuditLog');
        // Reports-only gets read on bookkeeping subjects
        can('read', 'Account');
        can('read', 'Customer');
        can('read', 'Vendor');
        can('read', 'Item');
        can('read', 'JournalEntry');
        can('read', 'TaxRate');
        can('read', 'WithholdingRate');
        can('read', 'Invoice');
        can('read', 'SalesReceipt');
        can('read', 'ReceivePayment');
    }
    else {
        // Phase 2: non-Admin roles get read-only on org metadata.
        // Wave 1+ extends with accounting-domain permissions.
        cannot('manage', 'Member');
        cannot('manage', 'Invitation');
        cannot('read', 'AuditLog');
    }
    return build();
}
//# sourceMappingURL=abilities.js.map